import React, {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";

/** "0" = user chose to show the incentives top bar this session; otherwise closed (default). */
const BANNER_DISMISSED_KEY = "bonusBannerDismissed";

const BonusBarContext = createContext(null);

function readBannerDismissedFromStorage() {
  if (typeof sessionStorage === "undefined") return true;
  try {
    return sessionStorage.getItem(BANNER_DISMISSED_KEY) !== "0";
  } catch (_) {
    return true;
  }
}

export function BonusBarProvider({ children }) {
  const [dismissed, setDismissed] = useState(() => readBannerDismissedFromStorage());

  const expandBonusBar = useCallback(() => {
    setDismissed(false);
    try {
      sessionStorage.setItem(BANNER_DISMISSED_KEY, "0");
    } catch (_) {}
  }, []);

  const dismissBonusBanner = useCallback((e) => {
    e?.stopPropagation?.();
    setDismissed(true);
    try {
      sessionStorage.setItem(BANNER_DISMISSED_KEY, "1");
    } catch (_) {}
  }, []);

  const toggleBonusBar = useCallback(() => {
    setDismissed((prev) => {
      const next = !prev;
      try {
        if (next) sessionStorage.setItem(BANNER_DISMISSED_KEY, "1");
        else sessionStorage.setItem(BANNER_DISMISSED_KEY, "0");
      } catch (_) {}
      return next;
    });
  }, []);

  const value = useMemo(
    () => ({
      bonusBarDismissed: dismissed,
      expandBonusBar,
      dismissBonusBanner,
      toggleBonusBar,
    }),
    [dismissed, expandBonusBar, dismissBonusBanner, toggleBonusBar]
  );

  return (
    <BonusBarContext.Provider value={value}>{children}</BonusBarContext.Provider>
  );
}

export function useBonusBar() {
  const ctx = useContext(BonusBarContext);
  if (!ctx) {
    throw new Error("useBonusBar must be used within BonusBarProvider");
  }
  return ctx;
}
